import {
  BlogPublicSidebarBanner,
  blogImageLoader,
  sidebarBannerImageUrl,
} from '@/lib/entities/blog';

import { FeedBackModalNew } from '@/lib/shared/components/Modal/FeedBackModalNew';
import { modal } from '@/lib/shared/components/Modal/ModalConnector';

import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import Link from 'next/link';

import styles from './ArticleSidebarBanner.module.scss';

type ArticleSidebarBannerProps = {
  banner?: BlogPublicSidebarBanner | null;
};

export const ArticleSidebarBanner = ({
  banner = null,
}: ArticleSidebarBannerProps) => {
  const { t } = useTranslation('index', { keyPrefix: 'blog' });

  if (banner && !banner.active) {
    return null;
  }

  const title = banner?.title?.trim() || t('sidebarBannerTitle');
  const buttonLabel = t('sidebarBannerCta');
  const linkUrl = banner?.linkUrl?.trim() || null;
  const imageUrl = sidebarBannerImageUrl(banner?.imageKey);

  const handleOpenLead = () => {
    modal.open(
      <FeedBackModalNew
        title="getExpert"
        sourceForm="blog-sidebar-banner"
        eventName={['blog']}
      />,
      { isFeedBackNew: true }
    );
  };

  return (
    <aside className={styles.banner} aria-label={title}>
      <div className={styles.banner__media}>
        <Image
          src={imageUrl}
          alt=""
          fill
          sizes="(max-width: 1023px) 100vw, 437px"
          style={{ objectFit: 'cover' }}
          loader={blogImageLoader}
        />
      </div>
      <div className={styles.banner__body}>
        <p className={styles.banner__title}>{title}</p>
        {linkUrl ? (
          <Link href={linkUrl} className={styles.banner__cta}>
            {buttonLabel}
          </Link>
        ) : (
          <button
            type="button"
            className={styles.banner__cta}
            onClick={handleOpenLead}
          >
            {buttonLabel}
          </button>
        )}
      </div>
    </aside>
  );
};
